import type { GrantFitTier } from "@/components/grant_suite/grantFitDisplay";

export type RecommendedGrant = {
  id: number;
  program_number: string | null;
  name: string;
  description: string | null;
  eligibility?: string | null;
  url?: string | null;
  scope?: "federal" | "regional";
  state?: string | null;
  fit_tier: GrantFitTier;
  fit_score: number;
};

export type GrantRecommendationsResponse = {
  grants: RecommendedGrant[];
  total_count: number;
  page: number;
  per_page: number;
  profile_complete: boolean;
  embedded: boolean;
  insights?: string | null;
};

export async function listGrantRecommendations(
  municipalityId: number,
  options?: { page?: number; perPage?: number; catalogScope?: string; state?: string; excludeFormula?: boolean },
): Promise<GrantRecommendationsResponse> {
  const params = new URLSearchParams();
  if (options?.page) params.set("page", String(options.page));
  if (options?.perPage) params.set("per_page", String(options.perPage));
  if (options?.catalogScope) params.set("catalog_scope", options.catalogScope);
  if (options?.state) params.set("state", options.state);
  if (options?.excludeFormula) params.set("exclude_formula", "true");
  const query = params.toString();
  const url = `/api/v1/municipalities/${municipalityId}/grant_recommendations${query ? `?${query}` : ""}`;
  const response = await fetch(url, { credentials: "include", headers: { Accept: "application/json" } });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error ?? "Failed to load recommendations");
  }
  return data;
}

export async function explainGrantFit(
  municipalityId: number,
  grantId: number,
): Promise<string> {
  const url = `/api/v1/municipalities/${municipalityId}/grant_recommendations/explanation?grant_id=${grantId}`;
  const response = await fetch(url, { credentials: "include", headers: { Accept: "application/json" } });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error ?? "Failed to explain grant fit");
  }
  return data.explanation ?? "";
}
